import { palette } from "lib/miolo";
import FundamentalsChartContext from "components/fundamentals/FundamentalsChartContext";
import { Fundaments } from "components/fundamentals/Fundaments";
import FundamentToggle from "components/fundamentals/FundamentToggle";
import type { ReactElement } from "react";

export default function FundamentalsToggles(): ReactElement {
  return (
    <FundamentalsChartContext.Consumer>
      {({ fundaments, toggle, selectOnly }) => (
        <>
          <FundamentToggle
            labelText="Caixa"
            labelTextColor={palette.fruitSalad}
            backgroundColor="#EEFBEF"
            isActive={fundaments.includes(Fundaments.CAPITAL_WITH_LIQUIDITY)}
            onClick={() => toggle(Fundaments.CAPITAL_WITH_LIQUIDITY)}
            onDoubleClick={() => selectOnly(Fundaments.CAPITAL_WITH_LIQUIDITY)}
          />

          <FundamentToggle
            labelText="Imóveis"
            labelTextColor={palette.oceanGreen}
            backgroundColor="#EEFBEF"
            isActive={fundaments.includes(Fundaments.TOTAL_VALUE_OF_REAL_ESTATE)}
            onClick={() => toggle(Fundaments.TOTAL_VALUE_OF_REAL_ESTATE)}
            onDoubleClick={() => selectOnly(Fundaments.TOTAL_VALUE_OF_REAL_ESTATE)}
          />

          <FundamentToggle
            labelText="Fundos"
            labelTextColor={palette.amazon}
            backgroundColor="#EEFBEF"
            isActive={fundaments.includes(Fundaments.TOTAL_OF_FUNDS_OF_FUNDS)}
            onClick={() => toggle(Fundaments.TOTAL_OF_FUNDS_OF_FUNDS)}
            onDoubleClick={() => selectOnly(Fundaments.TOTAL_OF_FUNDS_OF_FUNDS)}
          />

          <FundamentToggle
            labelText="Papéis"
            labelTextColor={palette.fruitSalad}
            backgroundColor="#EEFBEF"
            isActive={fundaments.includes(Fundaments.TOTAL_OF_OTHER_INVESTMENTS)}
            onClick={() => toggle(Fundaments.TOTAL_OF_OTHER_INVESTMENTS)}
            onDoubleClick={() => selectOnly(Fundaments.TOTAL_OF_OTHER_INVESTMENTS)}
          />

          <FundamentToggle
            labelText="Aluguéis"
            labelTextColor={palette.seaGreen}
            backgroundColor="#EEFBEF"
            isActive={fundaments.includes(Fundaments.TOTAL_FROM_RENTS)}
            onClick={() => toggle(Fundaments.TOTAL_FROM_RENTS)}
            onDoubleClick={() => selectOnly(Fundaments.TOTAL_FROM_RENTS)}
          />

          <FundamentToggle
            labelText="Ativos"
            labelTextColor={palette.scienceBlue}
            backgroundColor={palette.lilyWhite}
            isActive={fundaments.includes(Fundaments.TOTAL_ASSETS)}
            onClick={() => toggle(Fundaments.TOTAL_ASSETS)}
            onDoubleClick={() => selectOnly(Fundaments.TOTAL_ASSETS)}
          />

          <FundamentToggle
            labelText="Rendim."
            labelTextColor={palette.dixie}
            backgroundColor="#FCF4F4"
            isActive={fundaments.includes(Fundaments.DISTRIBUTED_INCOME)}
            onClick={() => toggle(Fundaments.DISTRIBUTED_INCOME)}
            onDoubleClick={() => selectOnly(Fundaments.DISTRIBUTED_INCOME)}
          />

          <FundamentToggle
            labelText="Taxas"
            labelTextColor={palette.mojo}
            backgroundColor="#FCF4F4"
            isActive={fundaments.includes(Fundaments.PERFORMANCE_AND_ADMINISTRATION_TAXES)}
            onClick={() => toggle(Fundaments.PERFORMANCE_AND_ADMINISTRATION_TAXES)}
            onDoubleClick={() => selectOnly(Fundaments.PERFORMANCE_AND_ADMINISTRATION_TAXES)}
          />

          <FundamentToggle
            labelText="Passivos"
            labelTextColor={palette.burntUmber}
            backgroundColor="#FCF4F4"
            isActive={fundaments.includes(Fundaments.TOTAL_LIABILITIES)}
            onClick={() => toggle(Fundaments.TOTAL_LIABILITIES)}
            onDoubleClick={() => selectOnly(Fundaments.TOTAL_LIABILITIES)}
          />

          <FundamentToggle
            labelText="Pat. Líq."
            labelTextColor={palette.royalBlue}
            backgroundColor={palette.selago}
            isActive={fundaments.includes(Fundaments.NET_EQUITY)}
            onClick={() => toggle(Fundaments.NET_EQUITY)}
            onDoubleClick={() => selectOnly(Fundaments.NET_EQUITY)}
          />

          <FundamentToggle
            labelText="V.P.C."
            labelTextColor={palette.mineShaft}
            backgroundColor={palette.catskillWhite}
            isActive={fundaments.includes(Fundaments.EQUITY_VALUE_PER_QUOTA)}
            onClick={() => toggle(Fundaments.EQUITY_VALUE_PER_QUOTA)}
            onDoubleClick={() => selectOnly(Fundaments.EQUITY_VALUE_PER_QUOTA)}
          />

          <FundamentToggle
            labelText="Rend."
            labelTextColor={palette.luxorGold}
            backgroundColor="#FCF9F0"
            isActive={fundaments.includes(Fundaments.YIELD_PER_QUOTA)}
            onClick={() => toggle(Fundaments.YIELD_PER_QUOTA)}
            onDoubleClick={() => selectOnly(Fundaments.YIELD_PER_QUOTA)}
          />
        </>
      )}
    </FundamentalsChartContext.Consumer>
  );
}
